import React from 'react';
import { GetUserQuery } from 'services/apollo';
import { useQuery } from '@apollo/react-hooks';

import {
  GOOGLE_DOCUMENT_CREATE,
  GOOGLE_DOCUMENT_ICON,
  GOOGLE_PRESENTATION_CREATE,
  GOOGLE_PRESENTATION_ICON,
  GOOGLE_SPREADSHEET_CREATE,
  GOOGLE_SPREADSHEET_ICON,
} from 'helpers/google';

import { Menu, MenuLink, MenuTitle, Loader } from 'components/shared';
import Icon from 'assets/icons/';

import styles from './CreateMenu.module.scss';

export interface CreateMenuProps {
  title?: string;
}

export const CreateMenu: React.FC<CreateMenuProps> = ({ title }) => {
  const { error, data } = useQuery(GetUserQuery, {
    fetchPolicy: 'cache-first',
  });

  if (data === undefined) return <Loader />;

  if (error) return <Loader color="Red" />;

  return (
    <Menu>
      {title && <MenuTitle>{title}</MenuTitle>}

      <MenuLink className={styles.link} href={GOOGLE_DOCUMENT_CREATE} target="_blank">
        <img
          alt="Create Google Document"
          className={styles.icon}
          src={GOOGLE_DOCUMENT_ICON as any}
        />
        Google Doc
      </MenuLink>

      <MenuLink className={styles.link} href={GOOGLE_SPREADSHEET_CREATE} target="_blank">
        <img
          alt="Create Google Spreadsheet"
          src={GOOGLE_SPREADSHEET_ICON as any}
          className={styles.icon}
        />
        Google Sheet
      </MenuLink>

      <MenuLink className={styles.link} href={GOOGLE_PRESENTATION_CREATE} target="_blank">
        <img
          alt="Create Google Presentation"
          src={GOOGLE_PRESENTATION_ICON as any}
          className={styles.icon}
        />
        Google Slide
      </MenuLink>

      <MenuLink
        className={styles.link}
        href={`https://hnshah.typeform.com/to/XQj2CP?email=${data.me.userProfile.email}`}
        target="_blank"
      >
        <Icon.Edit className={styles.icon} />
        Other
      </MenuLink>
    </Menu>
  );
};

export default CreateMenu;
